import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
const Bubbles = ({ item }) => {
  return (
    <TextBubble>
      <p>{item}</p>
    </TextBubble>
  );
};

const TextBubble = styled(motion.div)`
  background: #343434;
  padding: 0.3rem 0rem;
  margin-right: 2rem;
  border-radius: 20rem;
  margin-top: 1rem;
  cursor: pointer;

  @media (max-width: 900px) {
    margin: 0.5rem 0.5rem;
  }

  :hover {
    background: #515151;
  }

  p {
    padding: 0.1rem 1.2rem;
    font-family: "Work Sans", sans-serif;
    font-size: 0.8rem;

    @media (max-width: 396px) {
      font-size: 0.6rem;
      padding: 0.1rem 0.8rem;
    }
  }
`;

export default Bubbles;
